import { ProductGroupReferences } from '@product/const';
import { encodeUid } from '@shared/helpers';
import { StateUtils } from '@spartacus/core';
import { GROUP_REFERENCES } from '../product-state';

export const LOAD_GROUP_REFERENCES = '[CustomCatalog] Load Group References Load';
export const LOAD_GROUP_REFERENCES_SUCCESS = '[CustomCatalog] Load Group References Load Success';
export const LOAD_GROUP_REFERENCES_FAIL = '[CustomCatalog] Load Group References Load Fail';
export const GROUP_REFERENCES_RESET = '[CustomCatalog] Group References Load Reset';

export class LoadGroupReferences extends StateUtils.EntityLoadAction {
  readonly type = LOAD_GROUP_REFERENCES;

  constructor(
    public productCode: string,
    public referenceType: string,
  ) {
    super(GROUP_REFERENCES, encodeUid(productCode, referenceType));
  }
}

export class LoadGroupReferencesSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_GROUP_REFERENCES_SUCCESS;

  constructor(
    public productCode: string,
    public referenceType: string,
    public payload: ProductGroupReferences[],
  ) {
    super(GROUP_REFERENCES, encodeUid(productCode, referenceType), payload);
  }
}

export class LoadGroupReferencesFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_GROUP_REFERENCES_FAIL;

  constructor(
    public productCode: string,
    public referenceType: string,
    payload: any,
  ) {
    super(GROUP_REFERENCES, encodeUid(productCode, referenceType), payload);
  }
}

export class GroupReferencesReset extends StateUtils.EntityRemoveAllAction {
  readonly type = GROUP_REFERENCES_RESET;

  constructor() {
    super(GROUP_REFERENCES);
  }
}

export type GroupReferencesAction =
  | LoadGroupReferences
  | LoadGroupReferencesSuccess
  | LoadGroupReferencesFail
  | GroupReferencesReset;
